import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as documentUploadActions from '../../actions/documentUploadActions';
import {
	Modal,
} from 'react-bootstrap';



class UploadDocument extends React.Component {
	constructor(props, context) {
		super(props, context);
	}

	render() {
		let options = this.props.userTypeData;
		// let options = [{ _id: "5b02a542d4adde52002f5dfc", name: " Family History" }, { _id: "5b02a55380cef05217a7664e", name: 'Past History' }]
		return (
			<Modal show={this.props.openDocumentModal} size="modal-sm" onHide={this.props.hideDocumentModal}>
				<Modal.Header>

					{/* <ModalClose onClick={this.props.hideDocumentModal} /> */}
					<h4>Upload Document</h4>
					{/* <img src={require('../../images/images/logo.svg')} alt="" /> */}
				</Modal.Header>
				<Modal.Body>
					<div className="uploadDoc">

						<form className="login-form" id="documentUploadForm" name="form" onSubmit={this.props.uploadDocument.bind(this)}>

							<div className="boxMrgB choseFile">

								<div className="input-group inputBg text-center bggrey">
									<input type="file" className="form-control" name="file" id="fileID" onChange={this.props.onChange} style={{ display: "none" }} />
									<label htmlFor="fileID" className="fa fa-file cusfaicon"><span className="choosefile">Choose File</span></label>
								</div>
								<p>{this.props.fileOriginalName ? this.props.fileOriginalName : ''}</p>
								<span className="help-block">{this.props.file.message}</span>
							</div>
							<div className="boxMrgB">
								<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/file_img.png')} alt="" /></i></span>
									<input type="text" className="form-control" name="documentName" placeholder="Document Name" id="documentName" onChange={this.props.onChange} />

								</div><span className="help-block">{this.props.documentName.message}</span>	</div>
							<div className="boxMrgB">
								<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/file_img.png')} alt="" /></i></span>
									<select className="form-control selectBN" name="documentTypeId" onChange={this.props.onChange} id="documentTypeId" >
										<option value="">Select Document Type</option>
										{options.length > 0 ? options.map((option, index) => <option value={option._id} key={index}>{option.name}</option>) : 'No record'}</select>
								</div><span className="help-block">{this.props.documentTypeId.message}</span>	</div>


							{/* <div className="toppad"> */}
							{/* <button className="btn btn-warning btn-lg p-d-rst" type="button" onClick={this.props.uploadDocument.bind(this)}>Upload</button>   */}
							<button className="btn btn-warning btn-lg p-d-rst" type="submit" >Upload {this.props.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
							<button type="button" onClick={this.props.reSetModal} className="btn btn-cancel btn-default btn-lg p-d-rst pull-right">Reset</button>
							{/* </div> */}

						</form>
					</div>
				</Modal.Body>
				<Modal.Footer>
				</Modal.Footer>
			</Modal >
			// <div>
			// 	<h2>Upload Document</h2>
			// 	<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.props.closeModal}>
			// 		<span aria-hidden="true">&times;</span>
			// 	</button>
			// 	<form className="login-form" id="documentUploadForm" name="form" onSubmit={this.props.uploadDocument.bind(this)}>

			// 		<div className="boxMrgB choseFile">

			// 			<div className="input-group inputBg text-center bggrey">
			// 				<input type="file" className="form-control" ref="file" name="file" id="fileID" onChange={this.props.onChange} style={{ display: "none" }} />
			// 				<label htmlFor="fileID" className="fa fa-file cusfaicon"><span className="choosefile">Choose File</span></label>
			// 			</div>
			// 		</div>
			// 		<div className="boxMrgB">
			// 			<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/file_img.png')} alt="" /></i></span>
			// 				<input type="text" defaultValue={this.props.documentName} key={this.props.documentName} className="form-control" name="documentName" ref="documentName" placeholder="Document Name" onChange={this.props.onChange} />
			// 			</div>	</div>
			// 		<div className="boxMrgB">
			// 			<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/file_img.png')} alt="" /></i></span>
			// 				<select className="form-control selectBN" defaultValue={this.props.documentTypeId} key={this.props.documentTypeId} ref="documentTypeId" name="documentTypeId" onChange={this.props.onChange} >
			// 					<option value="">Select Document Type</option>
			// 					{options.length > 0 ? options.map((option, index) => <option value={option._id} key={index}>{option.name}</option>) : 'No record'}</select>
			// 			</div>	</div>

			// 		<div className="col-md-12 text-center">
			// 			<div className="toppad">
			// 				<button type="button" className="btn btn-warning btn-lg pd-btn" type="submit">Upload</button>  <button type="button" onClick={this.props.reSetModal} className="btn btn-cancel btn-default btn-lg p-d-rst">Reset</button>
			// 			</div>
			// 		</div>
			// 	</form>
			// </div >

		);
	}
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
	return {
		uploadData: state.uploadDocument.uploadData
	};
}

// this tells what action should expose on props
// bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(documentUploadActions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(UploadDocument);
